import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/apiConfig";

export default function ImageWithAuth({
  path,            // e.g. "/api/downloads/ciudadanos/123"
  token,           // your auth token
  alt = "",
  fallback = "/avatars/default-u.jpg",
  className,
  style,
  header = "x-auth-token", // or "Authorization" if you use Bearer
}) {
  const [src, setSrc] = useState(fallback);

  useEffect(() => {
    if (!path) { setSrc(fallback); return; }

    let objectUrl;
    const controller = new AbortController();
    const fullUrl = path.startsWith("http") ? path : `${API_BASE_URL}${path}`;

    (async () => {
      try {
        const res = await fetch(fullUrl, {
          headers: header === "Authorization"
            ? { Authorization: `Bearer ${token}` }
            : { [header]: token },
          signal: controller.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch {
        setSrc(fallback);
      }
    })();

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, token, header, fallback]);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      onError={() => setSrc(fallback)}
    />
  );
}
